import React from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { getApiV3PromoBannersIdDownload } from '@affiliate-cabinet/rest'
import { FlagNamesType, getFlagsPath } from '@affstore-ds/flags'
import { isEmpty } from '@affstore-ds/helpers'
import { Download0213 } from '@affstore-ds/icons'
import { Avatar, Card, Divider, Grid, Group, mediaHelper, SimpleGrid, Stack, useMediaQuery } from '@affstore-ds/uikit'

import { localesEntityTranslationKeys } from '../../../../entities/constants/localesEntity/translations/localesEntity.translationKeys'
import { MainPageHeader } from '../../../../shared/components/MainPageHeader'
import { PageStaticStack } from '../../../../shared/components/PageStaticStack'
import { TableEmptyData } from '../../../../shared/components/TableEmptyData'
import { PromoCardLoader } from '../../base/components/PromoCardLoader'
import { BannerModalGenerateLink } from './base/containers/BannerModalGenerateLink'
import { PromoBannersIdFiltersForm } from './base/containers/PromoBannersIdFiltersForm'
import { promoBannersByIdTranslationKeys } from './base/translations/promoBannersById.translationKeys'

import { usePromoBannersId } from './base/hooks/usePromoBannersId'

import { usePromoBannerDividerStyles } from './base/styles/PromoBannersDivider.styled'

export const PromoBannersById = () => {
  const { i18n } = useI18n()
  const { classes: promoBannerDividerClasses } = usePromoBannerDividerStyles()

  const { childBanners, childBannersLocales, filters, handleBackLink, handleFiltersChange, isFetching, rootBanner } = usePromoBannersId()
  const isGreaterThenMd = useMediaQuery(mediaHelper.greaterThen('md', false))

  return (
    <PageStaticStack data-testid="promo-banners-by-id-page">
      <Grid>
        <Grid.Col offset={0} span={12}>
          <MainPageHeader
            subtitle={i18n.t(promoBannersByIdTranslationKeys.promoBannerByIdDescription)}
            title={rootBanner?.name}
            onBackButtonClick={handleBackLink}
            withBackButton
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col offset={0} span={12}>
          <PromoBannersIdFiltersForm filters={filters} imageSizes={rootBanner?.sizes} loading={isFetching} onChange={handleFiltersChange} />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col offset={0} span={12}>
          {isFetching && (
            <SimpleGrid cols={{ base: 1, lg: 3, md: 2 }} spacing={24} verticalSpacing={24}>
              <PromoCardLoader />
              <PromoCardLoader />
              <PromoCardLoader />
            </SimpleGrid>
          )}
          {isEmpty(childBannersLocales) ? (
            <TableEmptyData />
          ) : (
            <Stack align="stretch" gap={24}>
              {childBannersLocales.map((locale) => (
                <Stack key={locale} gap={24}>
                  <Group gap={8}>
                    <Divider
                      label={i18n.t(localesEntityTranslationKeys[locale as keyof typeof localesEntityTranslationKeys])}
                      labelPosition="left"
                      classNames={promoBannerDividerClasses}
                      colorVariant="greyIron.4"
                      w="100%"
                    />
                    {/*<Link*/}
                    {/*  href={getApiV3PromoBannersIdDownload({*/}
                    {/*    id: childBanners[locale]?.[0]?.bannerId || 0,*/}
                    {/*    locale: locale,*/}
                    {/*    imageSizes: filters.imageSizes,*/}
                    {/*    fileFormats: filters.fileFormats,*/}
                    {/*  })}*/}
                    {/*  target="_blank"*/}
                    {/*  rel="noreferrer noopener"*/}
                    {/*  elementVariant={ButtonVariantEnum.TertiaryMain}*/}
                    {/*  elementSize={ButtonSizeEnum.S}*/}
                    {/*  rightSection={<Download0213 />}*/}
                    {/*>*/}
                    {/*  Download · {childBanners[locale].length}*/}
                    {/*</Link>*/}
                  </Group>
                  <SimpleGrid cols={{ base: 1, lg: 3, md: 2 }} spacing={24} verticalSpacing={24}>
                    {childBanners[locale].map((banner) => (
                      <Card
                        key={banner?.linkId}
                        withFluidContentHeight
                        badges={[
                          {
                            text: banner?.size,
                          },
                          {
                            icon: <Avatar avatarSize={16} src={getFlagsPath(banner?.locale.split('_')[1].toLowerCase() as FlagNamesType)} />,
                          },
                        ]}
                        customButtons={
                          <BannerModalGenerateLink
                            advertiserId={rootBanner?.advertiserId || 1}
                            bannerId={banner?.bannerId || 0}
                            bannerLink={banner?.link || ''}
                            locale={banner?.locale || 'en_US'}
                            size={banner?.size || ''}
                          />
                        }
                        externalLink={getApiV3PromoBannersIdDownload({
                          id: banner?.bannerId || 0,
                          imageSizes: banner?.size ? [banner?.size] : undefined,
                          locale: banner?.locale,
                        })}
                        generateLinkButtonProps={{
                          display: 'none',
                        }}
                        elementSize="S"
                        enableDynamicHeight={!isGreaterThenMd}
                        externalLinkIcon={<Download0213 />}
                        generateLinkText=""
                        imageAlt="promo banner image"
                        imageUrl={banner?.link || ''}
                        w="100%"
                      />
                    ))}
                  </SimpleGrid>
                </Stack>
              ))}
            </Stack>
          )}
        </Grid.Col>
      </Grid>
    </PageStaticStack>
  )
}
